import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { Campus }     from '../../models/api/campus.model';
import { Subscriber } from '../../models/api/subscriber.model';

import { AppConfigurationService } from '../configuration/app-configuration.service';
import { CampusService }           from './campus.service';

@Injectable({
    providedIn: 'root'
})
export class SubscriberService {

    private apiURL : string;
    private campus : Campus;

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService, private campusService: CampusService) { 

        this.apiURL = this.appConfigurationService.baseApi + '/subscriber';
        this.campus = this.campusService.campusActive;

    }
    
    subscribeByPopup(subscriber: Subscriber) : any {

        const url = this.apiURL + '/popup';
        return this.http.post<boolean>(url, subscriber);

    }

    subscribeByContactForm(subscriber: Subscriber) : any {

        const url = this.apiURL + '/contactform';
        return this.http.post<boolean>(url, subscriber);

    }
    
}
